import React, { Component } from "react";

class StatusDraftSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
      >
        <path
          className="svg"
          d="M3.3,13.4c-0.3,0.1-0.5,0.4-0.8,0.5c-0.9,0.4-0.9,0.7-1.6,0.2c-0.6-0.3-0.5-0.5-0.5-1.5c0-0.2,0-0.5,0-0.8
	C0.6,12,0.7,12,0.9,12.1c1.6-3,3.2-5.9,4.9-8.8C5.4,3.1,5,2.9,4.6,2.7c0,0.1-0.1,0.2-0.2,0.3C3,5.5,1.6,8.1,0.2,10.7
	C0.1,10.9,0,11.1,0,11.4c0,1.5,0,3,0,4.5c0.1,0,2.7-1.7,3.9-2.4c0.1-0.1,0.3-0.2,0.4-0.4c1.5-2.6,2.9-5.3,4.4-7.9
	c0-0.1,0-0.1,0.1-0.2C8,4.5,7.2,4.1,6.4,3.8c-1.6,2.8-3.2,5.8-4.9,8.8C2.1,12.8,2.7,13.2,3.3,13.4z M5.1,1.6c0.2-0.3,0.3-0.6,0.5-1
	C6,0,6.8-0.2,7.4,0.2c0.7,0.3,1.3,0.7,1.9,1.1c0.6,0.3,0.8,1,0.6,1.6C9.8,3.3,9.5,3.9,9.2,4.4C7.8,3.6,6.4,2.8,4.9,2
	C5,1.8,5.1,1.8,5.1,1.6z M15.5,16h-10c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.4V1.1h-3.8c-0.3,0-0.5-0.2-0.5-0.5S10.8,0,11.1,0
	h4.3C15.8,0,16,0.2,16,0.5v14.9C16,15.8,15.8,16,15.5,16z M13.7,3c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8
	C13.3,2.2,13.7,2.5,13.7,3z"
        />
      </svg>
    );
  }
}

export default StatusDraftSVG;



// WEBPACK FOOTER //
// ./src/svg/StatusDraftSVG.jsx